import Staffs           from "../../../domain/staff/Staffs";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_STAFFS = "SET_STAFFS",
}

export interface SetStaffsAction extends ResKaReduxAction {
  staffs: Staffs;
}

export type StaffsAction = SetStaffsAction;

export const setStaffsAction = (staffs: Staffs): SetStaffsAction => ({
  type: ACTION_TYPE.SET_STAFFS,
  staffs: staffs,
});